class INGSection {
  constructor(sectionEl, data) {
    this.sectionEl = sectionEl;
    this.data = data;
    this.gridEl = sectionEl.querySelector('.ing-section__grid');
    this._bindEvents();
  }

  static escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  _buildCardsHTML(items) {
    return items.map((card, index) => {
      var posClass = 'ing-card--pos-' + (index + 1);
      var html = '<div class="card-wrapper"><div class="ing-card ' + posClass + '">';
      if (card.symbol) {
        html += '<p class="ing-card__symbol">' + INGSection.escapeHtml(card.symbol) + '</p>';
      }
      if (card.name) {
        html += '<p class="ing-card__name">' + INGSection.escapeHtml(card.name) + '</p>';
      }
      if (card.list && card.list.length) {
        html += '<ul class="ing-card__list">';
        card.list.forEach(item => {
          if (item) {
            html += '<li class="ing-card__list-item">' + INGSection.escapeHtml(item) + '</li>';
          }
        });
        html += '</ul>';
      }
      html += '</div></div>';
      return html;
    }).join('');
  }

  update(variantId) {
    var vData = this.data.variants && this.data.variants[String(variantId)];
    var items = vData && vData.items && vData.items.length ? vData.items : null;
    var image = vData && vData.image ? vData.image : null;

    if (!this.gridEl) return;

    if (items) {
      this.gridEl.innerHTML = this._buildCardsHTML(items);
      this.sectionEl.classList.remove('ing-no-data');
    } else {
      this.gridEl.innerHTML = '';
      this.sectionEl.classList.add('ing-no-data');
    }
  var imageWrapper = this.sectionEl.querySelector('.varaint-image');

  if (imageWrapper) {
    if (image) {
      imageWrapper.innerHTML = '<img src="' + image + '" alt="" />';
      imageWrapper.style.display = '';
    } else {
      imageWrapper.innerHTML = '';
      imageWrapper.style.display = 'none';
    }
  }
  }

  _bindEvents() {
    document.addEventListener('variant-change', e => {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        this.update(String(e.detail.variant.id));
      }
    });

    document.body.addEventListener('change', e => {
      var t = e.target;
      if (
        t &&
        t.name === 'id' &&
        t.form &&
        String(t.form.id || '').indexOf('product-form-') === 0
      ) {
        this.update(t.value);
      }
    });
  }

  static init() {
    document.querySelectorAll('[data-ing-section]').forEach(sectionEl => {
      var sectionId = sectionEl.getAttribute('data-section-id');
      if (!sectionId) return;

      var scriptEl = document.getElementById('ing-data-' + sectionId);
      if (!scriptEl) return;

      var data;
      try {
        data = JSON.parse(scriptEl.textContent);
      } catch (e) {
        return;
      }

      new INGSection(sectionEl, data);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', INGSection.init);
} else {
  INGSection.init();
}
